import { render, staticRenderFns } from "./SmartCareSendDialog.vue?vue&type=template&id=641a4225&scoped=true"
import script from "./SmartCareSendDialog.vue?vue&type=script&lang=js"
export * from "./SmartCareSendDialog.vue?vue&type=script&lang=js"
import style0 from "./SmartCareSendDialog.vue?vue&type=style&index=0&id=641a4225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a4225",
  null
  
)

export default component.exports